(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Adds 'Back to top' functionality to an element with the ID 'back-to-top'
 * @example 
 * 1. Create a link-wrapper with ID 'back-to-top'
 * 2. Add an icon inside the link-wrapper such as an arrow
 * 3. Set position fixed: bottom right
 * 4. Set opacity to 0
 */
var BackToTop =
/*#__PURE__*/
function () {
  function BackToTop() {
    _classCallCheck(this, BackToTop);

    this.$backToTop = $('#back-to-top');
    this.toggleDistance = 50;

    if (this.$backToTop.length > 0) {
      this.init();
    }
  }

  _createClass(BackToTop, [{
    key: "init",
    value: function init() {
      var _this = this;

      window.onscroll = function () {
        return _this.scrollFunction();
      };

      this.$backToTop.on('click', function () {
        return _this.scrollToTop();
      });
    }
  }, {
    key: "scrollFunction",
    value: function scrollFunction() {
      if (document.body.scrollTop > this.toggleDistance || document.documentElement.scrollTop > this.toggleDistance) {
        this.$backToTop.css({
          'opacity': '1',
          'cursor': 'pointer',
          'pointer-events': 'all'
        });
      } else {
        this.$backToTop.css({
          'opacity': '0',
          'cursor': 'default',
          'pointer-events': 'none'
        });
      }
    }
  }, {
    key: "scrollToTop",
    value: function scrollToTop() {
      window.scrollTo(0, 0);
    }
  }]);

  return BackToTop;
}();

var _default = BackToTop;
exports.default = _default;

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Custom Dynamic Jump Menu (Table of Contents)
 * Requirements:
 * - A Content area with the class "js-jump-nav-sections"
 * - Each item in the ToCs should be it's own section
 * - A jump menu container with the class "js-jump-nav-menu"
 * - Jump menu should have link elements <a> equal to the number of sections in the content area (** This should be changed to be dynamic)
 */
var DyanmicTOC =
/*#__PURE__*/
function () {
  function DyanmicTOC() {
    _classCallCheck(this, DyanmicTOC);

    // Check if exists and initialize
    this.$dynamic_toc = $('.dynamic-toc');

    if (this.$dynamic_toc.length > 0) {
      this.init();
    }
  }

  _createClass(DyanmicTOC, [{
    key: "init",
    value: function init() {
      // Initialize component(s)
      this.toc_contents = this.$dynamic_toc.find('.dynamic-toc__contents').get(0);
      this.$toc_title = this.$dynamic_toc.find('.dynamic-toc__title');
      this.content_selector = this.$dynamic_toc.data('content');
      this.headings_selector = this.$dynamic_toc.data('headings');
      this.$content = $(this.content_selector).first();
      this.$headings = this.$content.find(this.headings_selector);
      this.toc_array = new Array();

      if (!this.$content || !this.$headings) {
        console.log('Could not locate contents or headings...');
        return;
      }

      this.prepareHeadings();
      this.populateToc();
      this.observeElements();
    }
  }, {
    key: "prepareHeadings",
    value: function prepareHeadings() {
      var _this = this;

      this.$headings.each(function (index, element) {
        var element_text = _this.replaceNbsps(element.textContent);

        var element_id = element_text.replace(/[^a-zA-Z0-9 ]/g, '').replaceAll(' ', '-').toLowerCase();
        element.id = element_id;
        var level = element.tagName.replace("H", "");
        var toc_item = {
          id: element_id,
          text: element_text,
          level: level //element: element,

        };

        _this.toc_array.push(toc_item);
      }); //console.log( this.toc_array );
    }
  }, {
    key: "replaceNbsps",
    value: function replaceNbsps(str) {
      var re = new RegExp(String.fromCharCode(160), "g");
      return str.replace(re, " ");
    }
  }, {
    key: "populateToc",
    value: function populateToc() {
      this.toc_contents.innerHTML = this.buildTree(this.toc_array);
      this.$toc_items = this.$dynamic_toc.find('.dynamic-toc__contents li');
    }
  }, {
    key: "buildTree",
    value: function buildTree(headers) {
      var _this2 = this;

      //Code from: https://stackoverflow.com/questions/63218812/how-to-create-a-nested-list-elements-of-heading-tags-in-the-same-order-from-dom
      var list = [];
      var nextLevelHeaders = [];
      var lastLevel = -1;

      if (headers.length === 0) {
        return "";
      }

      var buildSubTree = function buildSubTree() {
        if (nextLevelHeaders.length > 0) {
          list[list.length - 1] += _this2.buildTree(nextLevelHeaders); //console.log(list);
        }
      };

      headers.forEach(function (h) {
        if (lastLevel !== -1 && lastLevel < h.level) {
          nextLevelHeaders.push(h);
          return;
        }

        buildSubTree();
        lastLevel = h.level;
        list.push("<a class=\"toc__link\" href=\"#".concat(h.id, "\">").concat(h.text, "</a>"));
        nextLevelHeaders = [];
      });
      buildSubTree();
      var listHTML = list.map(function (i) {
        return "<li class=\"toc__item\">".concat(i, "</li>");
      }).join("");
      return "<ul class=\"toc__list\">".concat(listHTML, "</ul>");
    }
  }, {
    key: "observeElements",
    value: function observeElements() {
      var _this3 = this;

      this.sectionObserver = new IntersectionObserver(function (changes, observer) {
        _this3.sectionIntersection(changes, observer);
      }, {
        rootMargin: "-80px 0px -80px 0px",
        threshold: 0
      });
      this.$headings.each(function (index, element) {
        _this3.sectionObserver.observe(element);
      });
    }
  }, {
    key: "sectionIntersection",
    value: function sectionIntersection(changes, observer) {
      var _this4 = this;

      changes.forEach(function (change) {
        var isIntersecting = change.isIntersecting;
        var target = change.target;

        if (isIntersecting) {
          var sectionId = target.getAttribute('id');
          var linkHref = "#" + sectionId;

          _this4.$toc_items.removeClass('active');

          _this4.$dynamic_toc.find('a[href="' + linkHref + '"]').closest('.toc__item').addClass('active');
        }
      });
    }
  }]);

  return DyanmicTOC;
}();

var _default = DyanmicTOC;
exports.default = _default;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Sample module for adding new functionality or website components
 * @example 
 * #Add instructions here
 */
var Slider =
/*#__PURE__*/
function () {
  function Slider() {
    _classCallCheck(this, Slider);

    // Check if exists and initialize
    this.$slider = $('.js-slider');

    if (this.$slider.length > 0) {
      this.init();
    }
  }

  _createClass(Slider, [{
    key: "init",
    value: function init() {
      var _this = this;

      if (this.$slider.hasClass('services-slider')) {
        // Initialize component(s)
        this.sliderObject = this.$slider.slick({
          lazyLoad: 'ondemad',
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          adaptiveHeight: true,
          arrows: true,
          prevArrow: '<i class="fa-solid fa-chevron-left prev-arrow"></i>',
          nextArrow: '<i class="fa-solid fa-chevron-right next-arrow"></i>',
          responsive: [{
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }, {
            breakpoint: 479,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }]
        });
        this.sliderObject.on('init', function (slick) {
          _this.multiSlideAdaptiveHeight(_this.sliderObject);
        });
        this.sliderObject.on('beforeChange', function (slick, currentSlide, nextSlide) {
          _this.multiSlideAdaptiveHeight(_this.sliderObject);
        }); // when window is resized

        $(window).on('resize', function () {
          _this.multiSlideAdaptiveHeight(_this.sliderObject);
        });
        this.multiSlideAdaptiveHeight(this.sliderObject);
      }
    }
  }, {
    key: "multiSlideAdaptiveHeight",
    value: function multiSlideAdaptiveHeight(slider) {
      // set our vars
      var activeSlides = [];
      var tallestSlide = 0; // very short delay in order for us get the correct active slides

      setTimeout(function () {
        // loop through each active slide for our current slider
        $('.slick-track .slick-active', slider).each(function (item) {
          // add current active slide height to our active slides array
          activeSlides[item] = $(this).outerHeight();
        }); // for each of the active slides heights

        activeSlides.forEach(function (item) {
          // if current active slide height is greater than tallest slide height
          if (item > tallestSlide) {
            // override tallest slide height to current active slide height
            tallestSlide = item;
          }
        }); // set the current slider slick list height to current active tallest slide height

        $('.slick-list', slider).height(tallestSlide);
      }, 10);
    }
  }]);

  return Slider;
}();

var _default = Slider;
exports.default = _default;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Opens social sharing links in a small popup window
 * @example 
 * 1. Add the class .js-social-share-popup to social share links
 */
var SocialSharePopups =
/*#__PURE__*/
function () {
  function SocialSharePopups() {
    _classCallCheck(this, SocialSharePopups);

    // Check if exists and initialize
    this.$socialShareLinks = $('.js-social-share-popup');
    this.viewportMinSize = 768;

    if (this.$socialShareLinks.length > 0 && $(window).width() > this.viewportMinSize) {
      this.init();
    }
  }

  _createClass(SocialSharePopups, [{
    key: "init",
    value: function init() {
      var _this = this;

      // Initialize component(s)
      console.log('social popups initialized');
      this.$socialShareLinks.on('click', function (e) {
        return _this.handleSocialShareLinkClick(e);
      });
    }
  }, {
    key: "handleSocialShareLinkClick",
    value: function handleSocialShareLinkClick(e) {
      e.preventDefault();
      var targetUrl = $(e.currentTarget).attr('href');
      var newWin = window.open(targetUrl, 'sharewindow', 'width=600,height=400');
    }
  }]);

  return SocialSharePopups;
}();

var _default = SocialSharePopups;
exports.default = _default;

},{}],5:[function(require,module,exports){
"use strict";

var _backToTop = _interopRequireDefault(require("./modules/back-to-top"));

var _socialSharePopups = _interopRequireDefault(require("./modules/social-share-popups"));

var _slider = _interopRequireDefault(require("./modules/slider"));

var _dynamicToc = _interopRequireDefault(require("./modules/dynamic-toc"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */
window.$ = jQuery;
$(document).ready(function () {
  $('html').addClass('js-on-load'); // const backToTop = new BackToTop();
  // const socialSharePopups = new SocialSharePopups();

  var slider = new _slider.default();
  var dyanmicTOC = new _dynamicToc.default(); // plugin('ResponsiveTabs', ResponsiveTabs);
});

},{"./modules/back-to-top":1,"./modules/dynamic-toc":2,"./modules/slider":3,"./modules/social-share-popups":4}]},{},[5]);
